import { ref, onMounted, onUnmounted } from 'vue'

function detectMobile(): boolean {
  const touch = 'ontouchstart' in window || navigator.maxTouchPoints > 0
  const ua = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  const narrow = window.innerWidth <= 768
  return touch && (ua || narrow)
}

function detectStandalone(): boolean {
  return (
    (window.navigator as any).standalone === true ||
    window.matchMedia('(display-mode: standalone)').matches ||
    window.matchMedia('(display-mode: fullscreen)').matches
  )
}

export function useMobile() {
  const isMobile = ref(detectMobile())
  const isStandalone = ref(detectStandalone())

  function onResize() {
    isMobile.value = detectMobile()
  }

  onMounted(() => window.addEventListener('resize', onResize))
  onUnmounted(() => window.removeEventListener('resize', onResize))

  return { isMobile, isStandalone }
}
